/* -----------------------------------------------------------------------------------------

    THSI FILE CONTAINS THE IMPORTANT WEB3/UI CONFIGURATIONS FOR THE APP

----------------------------------------------------------------------------------------- */
import React from "react";
import { FaEthereum } from "react-icons/fa";
import { BiMoviePlay, BiMoney, BiArea, BiBook, BiLock } from "react-icons/bi";
import { MdArticle } from "react-icons/md";

export const appSettings = {
  /* APP MAIN LOGO - REPLACE IT FROM THE PUBLIC FOLDER */
  logo: "https://images.versx.io/public/logo.svg",

  /* APP MAIN LOGO WIDTH - CHANGE IT ACCORDING TO YOUR OWN LOGO */
  logoWidth: "140",

  /* APP BRAND NAME - USED IN ALL PAGES & META TAGE - CHANGE TO YOUR OWN BRAND NAME*/
  brandName: "Versx Video",

  /* APP BRAND DESCRIPTION - USED IN HOME PAGE & META TAGS - PUT A SENTENCE THAT DESCRIBE YOUR APP*/
  brandDescription: "Decentralized Videos Streaming App",

  /* APP AUTHOR - CHANGE IT IF YOU HAVE A LICENSE KEY OR PURCHASE CODE */
  marketplaceAuthor: "Versx",

  /* COPYRIGHTS BRAND NAME */
  copyrightsBrand: "Versx",

  /* TEXT IDENTIFIER FOR THE NETWORK WHERE THE APP IS UP AND RUNNING, YOU CAN WRITE WHATEVER YOU WANT */
  activeNetworkName: "Ethereum",

  /* COPYRIGHTS LINK - REPLACE IT IF YOU HAVE A LICENSE KEY OR A PURCHASE CODE */
  copyrightsLink: "https://versx.io",

  /* THE NETWORK RPC URL WHERE YOUR CONTRACTS ARE DEPOLYED ON, CHECK THE EXACT RPC URL FROM HERE https://chainlist.org */
  rpcUrl: "https://damp-compatible-feather.quiknode.pro",

  /* THE CHAIN ID of NETWORK WHERE YOUR CONTRACTS ARE DEPOLYED ON, GET IT FROM HERE https://chainlist.org */
  networkId: 1,

  /* THE BLOCK SCAN EXPLORER WHRE YOU CAN TRACK THE TRANSACTIONS */
  blockExplorerUrls: "https://etherscan.io/",

  /* THE NATIVE CURRENCY THAT YOUR APP WILL USE FOR TRANSACTIONS */
  currency: "ETH",

  /* API ROOT ENDPOINT FOR SAVING VIDEO ASSETS ON THE SERVER */

  // APIURL: "http://127.0.0.1:8000/api/video/store",

  APIURL: "https://backendstreamlify.versx.io/public/api/video/store",
  /* ENDPOINT FOR ASK FOR A FEATURE FORM */
  requestFeatureFormId: "mrgvzdyy",

  /* GENERS LIST - ADD OR DELETE FROM THEM AS YOU NEED */
  genresOptions: [
    {
      label: "General",
      value: "General",
      icon: <BiMoviePlay size='2rem' className='text-primary' />,
    },

    {
      label: "Educational",
      value: "Educational",
      icon: <BiBook size='2rem' className='text-primary' />,
    },
    {
      label: "Finance",
      value: "Finance",
      icon: <BiMoney size='2rem' className='text-primary' />,
    },

    {
      label: "Crypto",
      value: "Crypto",
      icon: <FaEthereum size='2rem' className='text-primary' />,
    },
    {
      label: "NFT",
      value: "NFT",
      icon: <MdArticle size='2rem' className='text-primary' />,
    },
    {
      label: "Blockchain",
      value: "Blockchain",
      icon: <BiLock size='2rem' className='text-primary' />,
    },
    {
      label: "Defi",
      value: "Defi",
      icon: <BiArea size='2rem' className='text-primary' />,
    },
  ],
};
